// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCacheToolToolType } from "../DataCacheToolEnums.js";
import { DataCacheTool } from "../DataCacheTool.js";

export let FibonacciSpiralDataCacheTool = function ()
{
    this.direction = 0;
    this.k_spiral = 0;

    DataCacheTool.apply(this);

    this.ToolType = DataCacheToolToolType.FibonacciSpiral;
    this.InitPoints(222);
};

FibonacciSpiralDataCacheTool.prototype = Object.create(DataCacheTool.prototype);

FibonacciSpiralDataCacheTool.prototype.InitBlock = function ()
{
    DataCacheTool.prototype.InitBlock.apply(this);

    this.direction = 1;
    this.k_spiral = 1.618;
};

FibonacciSpiralDataCacheTool.prototype.MaxPointsCount = function () { return 2; };
FibonacciSpiralDataCacheTool.prototype.MinPointsCount = function () { return 2; };
FibonacciSpiralDataCacheTool.prototype.AdditionalPointsCount = function () { return 220; };